import React, { useState } from 'react';
import Modal from '../../Shared/Modal';

function CookingTime({ cookingTime, onChange, readOnly }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempValue, setTempValue] = useState(cookingTime || '');

  const predefinedTimes = [
    { label: "15m", value: 15 },
    { label: "30m", value: 30 },
    { label: "45m", value: 45 },
    { label: "1h", value: 60 },
    { label: "1h 30m", value: 90 },
    { label: "2h", value: 120 },
    { label: "2h 30m", value: 150 },
    { label: "3h", value: 180 },
    { label: "> 3h", value: 200 },
  ];

  const labelClass = "text-[clamp(0.65rem,1.2vw,0.875rem)] font-semibold leading-tight mb-[1%]";
  const textClass = "text-[clamp(0.65rem,1.2vw,0.875rem)] font-normal leading-tight truncate";

  return (
    <div className="h-full w-full flex flex-col items-center justify-center px-[3%] text-center text-[#5a3e36]">
      <label className={labelClass}>
        Time:
      </label>

      {readOnly ? (
        <div className={textClass}>
          {
            predefinedTimes.find(opt => opt.value === cookingTime)?.label
            || (cookingTime
                ? `${cookingTime} min`
                : <span className="text-transparent select-none">.</span>
              )
          }
        </div>
      ) : (
        <div
          className="
            w-full max-w-[9rem] sm:max-w-[10rem]
            h-[clamp(1.8rem,2.2rem,2rem)]
            text-[clamp(0.65rem,1.2vw,0.875rem)]
            border border-[#e0c3a5] rounded
            bg-white flex items-center justify-center
            cursor-pointer select-none
          "
          onClick={() => {
            setTempValue(cookingTime || '');
            setIsModalOpen(true);
          }}
        >
          {
            predefinedTimes.find(opt => opt.value === cookingTime)?.label
            || cookingTime || <span className="text-transparent select-none">.</span>
          }
        </div>
      )}

      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} title="Set Cooking Time">
        <div className="flex flex-col gap-3">
          <select
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            className="
              w-full text-center text-base 
              border border-dominant-purple rounded 
              px-3 py-2 
              focus:outline-none focus:ring-2 focus:ring-rich-gold
              placeholder:text-slate-400
            "
          >
            <option value="">Select time</option>
            {predefinedTimes.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>

          <button
            className="bg-rich-gold text-white px-6 py-2.5 rounded-xl text-base font-marketing hover:bg-dominant-purple hover:text-white transition duration-250 ease-out-quad"
            onClick={() => {
              const parsed = parseInt(tempValue, 10);
              if (predefinedTimes.find((t) => t.value === parsed)) {
                onChange(parsed);
                setIsModalOpen(false);
              } else {
                alert("Please select a valid time.");
              }
            }}
          >
            Confirm
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default CookingTime;